import { Colors, WarningFilledIcon } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const WarningIcon = styled(WarningFilledIcon)`
  color: ${Colors['text-icon--status-warning']};
`;
